import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { AppServices } from 'services/AppServices';
import Locale from 'localization/Localization';
import { Spinner } from 'components/common/Spinner';
import Alert from 'react-bootstrap/Alert';
import Collapse from 'react-bootstrap/Collapse';
import { HttpStatusCode } from 'models/HttpStatusCode';

interface LoginFormProps {
	redirectPath: string;
}

interface LoginFormState {
	userEmail: string;
	userPassword: string;
	loginInProgress: boolean;
	alert?: JSX.Element;
	redirectPath?: string;
}

export class LoginForm extends React.Component<LoginFormProps, LoginFormState>
{
	constructor(props: LoginFormProps) {
		super(props);

		this.state = {
			userEmail: '',
			userPassword: '',
			loginInProgress: false,
			redirectPath: undefined
		};

		this.onEmailChanged = this.onEmailChanged.bind(this);
		this.onPasswordChanged = this.onPasswordChanged.bind(this);
		this.onSubmitClick = this.onSubmitClick.bind(this);
		this.onResendVerification = this.onResendVerification.bind(this);
	}

	private onEmailChanged(event: React.ChangeEvent<HTMLInputElement>) {
		this.setState({ userEmail: event.target.value });
	}

	private onPasswordChanged(event: React.ChangeEvent<HTMLInputElement>) {
		this.setState({ userPassword: event.target.value });
	}

	private onResendVerification(e: React.MouseEvent<HTMLAnchorElement>) {
		e.preventDefault();

		this.setState({
			alert: undefined,
			loginInProgress: true
		})

		AppServices.loginService.resendVerification(this.state.userEmail)
			.then(() => {
				this.setState({
					alert: <Alert variant='success'>{Locale.get('login_verificationSend')}</Alert>,
					loginInProgress: false
				})
			})
			.catch(reason => {
				console.error(reason);
				this.setState({
					alert: <Alert variant='success'>{Locale.get('login_errorUnknown')}</Alert>,
					loginInProgress: false
				})
			})
	}

	private onSubmitClick(event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault();

		this.setState({ loginInProgress: true, alert: undefined });

		AppServices.loginService.logIn(this.state.userEmail, this.state.userPassword)
			.then((result) => {
				switch (result) {
					case HttpStatusCode.OK:
						{
							this.setState({ loginInProgress: false, redirectPath: this.props.redirectPath });
							break;
						}
					case HttpStatusCode.Unauthorized:
						{
							this.setState({
								loginInProgress: false,
								alert: <>
									<Alert variant='warning'>
										{Locale.get('login_errorEmailNotVerified')}<br />
										<Link to='' onClick={this.onResendVerification}>
											{Locale.get('login_sendNewVerification')}
										</Link>
									</Alert>
								</>
							});
							break;
						}
					case HttpStatusCode.Forbidden:
						{
							this.setState({
								loginInProgress: false,
								alert: <Alert variant='danger'>{Locale.get('login_errorLoginFailed')}</Alert>
							})
							break;
						}
					default:
						throw result;
				}
			})
			.catch((reason) => {
				console.error(reason);

				this.setState({
					loginInProgress: false,
					alert: <Alert variant='danger'>{Locale.get('login_errorUnknown')}</Alert>
				})
			});
	}

	public render() {
		if (this.state.redirectPath !== undefined && this.state.redirectPath !== null)
			return <Redirect to={this.state.redirectPath} />;

		return <div className='login-container'>
			<h2>{Locale.get('login_header')}</h2>
			<Collapse in={this.state.alert !== undefined}>
				<div>
					{this.state.alert}
				</div>
			</Collapse>
			<form onSubmit={this.onSubmitClick}>
				<label className='input-label' htmlFor='loginUserEmail'>{Locale.get('login_emailLabel')}</label>
				<input required type='email' id='loginUserEmail' onChange={this.onEmailChanged} disabled={this.state.loginInProgress} />
				<label className='input-label' htmlFor='loginUserPassword'>{Locale.get('login_passwordLabel')}</label>
				<input required type='password' id='loginUserPassword' onChange={this.onPasswordChanged} disabled={this.state.loginInProgress} />
				{
					this.state.loginInProgress === false
						? <div className='submit-container'>
							<input type='submit' value={Locale.get('login_submitButton')} disabled={this.state.loginInProgress} />
						</div>
						: <div className='spinner-container'>
							<Spinner height='25px' margin='0 10px' />
						</div>
				}

				<Link to='/reset'>{Locale.get('login_resetPasswordLink')}</Link><br />
				{/* <Link to='/signup'>{L.get('login_createAccountLink')}</Link> */}
			</form>
		</div>;
	}
}
